/**
 * Created by Angelika on 24.10.2017.
 */
export const UPDATE_ACTIVITY_TIMER = 2*60*1000;
export const UPDATE_EPG_INTERVAL = 30*1000;
export const CHANNEL_CARDS_MAX_COUNT = 5;
export const VIDEO_INITIAL_VOLUME = 0.5;
export const VIDEO_DISACTIVATE_CONTROLS = 5000;
export const FAVORITE_CHANGE_TIMEOUT = 500;
export const RETURN_TIMEOUT = 200;
export const EPG_COLUMNS_COUNT = 3;
export const INPUT_MAX_LENGTH = 100;
export const REGISTRATION_URL = 'https://api.briz.ua/server.php/ott/registration';
export const CHANNEL_FRAME = 'CHANNEL_FRAME';
export const PLAYER_FRAME = 'PLAYER_FRAME';
export const USERDATA_FRAME = 'USERDATA_FRAME';


// WEBPACK FOOTER //
// ./src/constants/defines.js